import BaseEntryPoint from './base_entry_point';
import { EventBus } from '../event_bus';
import { DataLoader } from '../data_loader';
import { PlayerFactory } from '../player_factory';
import { RenderingFactory } from '../rendering_factory';
import { AnnotationEngineFactory } from '../annotation_engine_factory';
import { APPLICATION_EVENT } from 'constants/events';

export default class Wrapper extends BaseEntryPoint {
    initialize(options) {
        options.container = PlayerFactory.containerizePlayer(options);

        this.eventBus = new EventBus();
        this.dataLoader = new DataLoader(options, this.eventBus);
        this.renderer = RenderingFactory.create(options, this.eventBus);
        this.playerAdapter = PlayerFactory.create(options, this.eventBus);
        this.annotationEngine = AnnotationEngineFactory.create(options, this.eventBus);

        this.dataLoader
            .loadSetup()
            .then(data => this.eventBus.emit(APPLICATION_EVENT.LOAD, data));
    }
}